// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608271127/js/" + chunkId + "." + {"44":"1a087211","225":"c316fd3d","481":"6872c221","486":"aac18eb9","770":"d94b4fde"}[chunkId] + ".0.5677919219430081.chunk.js";
};